import { Component, ComponentFactoryResolver, OnInit } from "@angular/core";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { ReelsService } from "../../../../services/reels.service";
import { SwalService } from "../../../../shared/services/swal.service";
import { BroadcastService } from "../../../../shared/services/broadcast.service";
import { NRModalService } from "../../../../shared/modal/services/nrmodal.service";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { CustomersService } from "../../../../services/customers.service";
import { ControlService } from "../../../../services/control.service";
import { MediasService } from "../../../../services/medias.service";
import { distinctUntilChanged, map, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import {
	EventModel,
	EventSubscriptionType,
	EventType,
} from "../../../../shared/interfaces/event.model";
import { DynamicHostModel } from "../../../../shared/modal/models/dynamic-host.model";
import { CreateEditReelComponent } from "../../../admin/svs/reels/create-edit-reel/create-edit-reel.component";
import { EditCreateMediaComponent } from "../../../admin/svs/media/edit-create-media/edit-create-media.component";
import { GroupsService } from "../../../../services/groups.service";
import { DuplicateReelComponent } from "./duplicate-reel/duplicate-reel.component";
import { MenuItem } from "primeng/api";

export type AssignedTime = "mat" | "ves" | "";

export interface MediaItem {
	id: number;
	name: string;
	path: string;
	description: string | null;
	type: "VIDEO" | "IMAGE" | string;
	fecha: string; // fecha de inicio de vigencia (ISO)
	vigencia: string; // fecha de fin de vigencia (ISO)
	created_at: string;
	updated_at: string;
	deleted_at: string | null;
	thumb: string | null;
	size: string | null;
	duration_seconds: number | null;
	checksum: string | null;
	client_id: number;
	resource_url: string;
	thumb_url: string;
	total_views_value: number;
	categories: MediaCategory[];
	total_views: MediaTotalViews | null;
	media_views: MediaView[];
	assigned_time: AssignedTime;
}

/* 
  Representa una categoría asociada al media (p. ej. “COMERCIAL”, “GENÉRICA”).
*/
export interface MediaCategory {
	id: number;
	name: string;
	description: string;
	created_at: string;
	updated_at: string;
	deleted_at: string | null;
	pivot?: {
		media_id: number;
		category_id: number;
		created_at: string;
		updated_at: string;
	};
}

/* 
  Representa el total de vistas acumuladas del media.
*/
export interface MediaTotalViews {
	media_id: number;
	total: string; // normalmente viene como string en la respuesta
}

/* 
  Representa una vista individual (registro histórico o diario).
*/
export interface MediaView {
	// puedes extender según lo que devuelva tu endpoint de media_views
	id?: number;
	date_view?: string;
	total_view?: number;
}

@Component({
	selector: "app-design-reels",
	templateUrl: "./design-reels.component.html",
	styleUrls: ["./design-reels.component.scss"],
})
export class DesignReelsComponent implements OnInit {
	private readonly atComponentDestroy = new Subject<void>();

	isAdmin: boolean = false;
	clientes: any[] = [];
	medias: any[] = [];
	campanias: any[] = [];
	photos: any[] = [];
	selectedClientId: number | null = null;
	selectedReel: any | null = null;
	selectedReelName: string | null = null;
	selectedReelId: number | null = null;
	canAddGroup: boolean | true = true;

	CurrentType: string | null = null;

	Group_id: number | null = null;
	currentGroup_id: number | null = null;
	UnitsGroup: any[] = [];

	ReelsByUser = [];

	searchTerm: string = "";
	soloVigentes: boolean = true;
	message: string = "Cargando...";
	isLoading: boolean = false;
	isLoadingRepertorio: boolean = false;

	reelsDisponibles = [
		{
			id: 1,
			name: "Campaña Octubre Pepsi",
			descripcion: "Promos 2x1",
			items: [
				/* ...clips... */
				"prueba",
			],
			thumbs: [
				"url-thumb-1.jpg",
				"url-thumb-2.jpg",
				"url-thumb-3.jpg",
				"url-thumb-4.jpg",
			],
		},
		{
			id: 2,
			name: "Campaña Octubre coca",
			descripcion: "Promos 2x1",
			medias: [
				/* ...clips... */
			],
			thumbs: [
				"url-thumb-1.jpg",
				"url-thumb-2.jpg",
				"url-thumb-3.jpg",
				"url-thumb-4.jpg",
			],
		},
	];

	repertorio: MediaItem[] = [];
	repertorioBase: MediaItem[] = [];

	reelTimeline: MediaItem[] = [];
	reelTimelineBase: MediaItem[] = [];
	reelTimelineCopy: MediaItem[] = [];
	totalDurationSelected: string = null;
	totalDurationSelectedBase: string = null;

	readonly assignedTimeOptions = [
		{
			label: "Todo horario",
			value: "",
			icon: "pi pi-clock",
		},
		{
			label: "Matutino",
			value: "mat",
			icon: "pi pi-sun",
		},
		{
			label: "Vespertino",
			value: "ves",
			icon: "pi pi-moon",
		},
	];

	constructor(
		private reelsService: ReelsService,
		private mediasService: MediasService,
		private groupsService: GroupsService,
		private swal: SwalService,
		private broadcast: BroadcastService,
		private componentFactoryResolver: ComponentFactoryResolver,
		private nrModal: NRModalService,
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private customerService: CustomersService,
		private controlService: ControlService,
	) {
		if (this.activatedRoute.snapshot.params["id"]) {
			this.Group_id =
				parseInt(this.activatedRoute.snapshot.params["id"]) || null;
		}
	}

	async ngOnInit(): Promise<void> {
		this.message = "Cargando...";
		this.isLoading = true;

		this.controlService
			.isAdmin()
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((res) => {
				this.isAdmin = res.is_admin;
			});

		const response = await this.groupsService.getAll();
		this.UnitsGroup = response.response;

		this.initializeBroadcastSubscriptions();

		this.activatedRoute.paramMap
			.pipe(
				map((params) => {
					const id = params.get("id");

					if (id === null) {
						return null;
					}

					const parsedId = Number(id);

					return Number.isNaN(parsedId) ? null : parsedId;
				}),
				distinctUntilChanged(),
				takeUntil(this.atComponentDestroy),
			)
			.subscribe(async (groupId) => {
				this.Group_id = groupId;
				this.currentGroup_id = groupId;

				await this.loadGroupData();
			});

		this.customerService.getLimits().then((res: any) => {
			const reelsLimit = res.reels || {
				used: 0,
				limit: 0,
			};

			this.canAddGroup = reelsLimit.used < reelsLimit.limit;
		});
	}

	private async loadGroupData(): Promise<void> {
		this.isLoading = true;
		this.message = "Cargando...";

		this.reelTimeline = [];
		this.reelTimelineBase = [];

		this.selectedReel = null;
		this.selectedReelId = null;
		this.selectedReelName = null;

		this.totalDurationSelected = "00:00";
		this.totalDurationSelectedBase = "00:00";

		try {
			await this.obtenerReel();
		} catch (error) {
			console.error("Error al cargar el grupo:", error);
		} finally {
			this.isLoading = false;
		}
	}

	private initializeBroadcastSubscriptions(): void {
		this.broadcast
			.onEvent(EventSubscriptionType.TYPE, EventType.MODAL)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((event: EventModel) => {
				const props = this.prepareProps(event);
				console.log(props);

				if (props) {
					console.log("props listos");
					this.nrModal.open(
						props,
						props.modalModel?.modalConfiguration?.modalSize || "xl",
					);
				}
			});

		this.broadcast
			.onEvent(EventSubscriptionType.TYPE, EventType.DATATABLE)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(() => {
				this.obtenerReel();
				this.getMedias();
			});
	}

	copy_timeline(): void {
		this.reelTimelineCopy = this.reelTimeline.map((media: MediaItem) => ({
			...media,
		}));
	}

	paste_timeline(): void {
		this.reelTimeline = this.reelTimelineCopy.map((media: MediaItem) => ({
			...media,
		}));

		this.recalculateTimelineDuration();
	}

	private recalculateTimelineDuration(): void {
		const totalSeconds = this.reelTimeline.reduce(
			(total: number, media: MediaItem) =>
				total + (Number(media.duration_seconds) || 0),
			0,
		);

		this.totalDurationSelected = this.formatDuration(totalSeconds);
	}

	delete_reel() {
		this.delete(this.selectedReelId);
	}

	private async refreshSelectedReelAfterSave(): Promise<void> {
		const reelId = this.selectedReelId;

		if (!reelId) {
			return;
		}

		const response = await this.reelsService.show(reelId);

		const reelFromServer = response?.response ?? response;

		const updatedMedias: MediaItem[] = (reelFromServer?.medias || []).map(
			(media: any) => this.normalizeTimelineMedia(media),
		);

		const totalSeconds = updatedMedias.reduce(
			(total: number, media: MediaItem) =>
				total + (Number(media.duration_seconds) || 0),
			0,
		);

		const updatedReel = {
			...this.selectedReel,
			...reelFromServer,
			medias: updatedMedias,
			totalDuration: this.formatDuration(totalSeconds),
		};

		/*
		 * Reemplazar el reel dentro de la lista local.
		 * Se crea un arreglo nuevo para activar la
		 * detección de cambios de Angular.
		 */
		this.ReelsByUser = this.ReelsByUser.map((reel: any) =>
			Number(reel.id) === Number(reelId) ? updatedReel : reel,
		);

		/*
		 * Actualizar el reel seleccionado.
		 */
		this.selectedReel = updatedReel;
		this.selectedReelName = updatedReel.name;

		/*
		 * Actualizar timeline visible y copia base.
		 */
		this.reelTimeline = updatedMedias.map((media: MediaItem) => ({
			...media,
		}));

		this.reelTimelineBase = updatedMedias.map((media: MediaItem) => ({
			...media,
		}));

		this.totalDurationSelected = updatedReel.totalDuration;

		this.totalDurationSelectedBase = updatedReel.totalDuration;
	}

	prepareProps(event: EventModel): any {
		const props: DynamicHostModel = new DynamicHostModel();
		props.instantiated = false;
		props.modalModel = {
			component: null,
			componentFactoryResolver: this.componentFactoryResolver,
			data: event.data.item || {},
		};

		switch (event.name) {
			case "reels.add":
				props.modalModel.component = CreateEditReelComponent;
				props.modalModel.modalConfiguration = {
					title: "Agregar Reel",
				};
				props.modalModel.data = {
					is_admin: this.isAdmin,
				};
				break;
			case "medias.add":
				props.modalModel.component = EditCreateMediaComponent;
				props.modalModel.modalConfiguration = {
					title: "Agregar Media",
				};
				props.modalModel.data = { IsAdmin: this.isAdmin, item: {} };
				break;
			case "reels.edit":
				props.modalModel.component = CreateEditReelComponent;
				props.modalModel.modalConfiguration = {
					title: "Editar Reel",
				};
				const reel = {
					...this.selectedReel,
					medias: [],
				};

				props.modalModel.data = {
					is_admin: this.isAdmin,
					...this.selectedReel,
				};
				break;
			case "reels.duplicate":
				console.log("Recibiendo la señal");
				props.modalModel.component = DuplicateReelComponent;
				props.modalModel.modalConfiguration = {
					title: "Duplicar Reel",
				};
				props.modalModel.data = {
					is_admin: this.isAdmin,
					data: {
						...this.selectedReel,
					},
				};
				break;
			default:
				return false;
		}

		return props;
	}

	/**
	 * Get User confirmation and send the signal to the server
	 * @param data
	 */
	delete(data): void {
		const swalParams = {
			title: "¿Estás seguro de querer eliminar el reel?",
		};

		this.swal.warning(swalParams).then((result) => {
			if (result.value) {
				this.reelsService.delete(data).subscribe((resp: any) => {
					if (resp.success) {
						this.swal
							.success({ title: "Reel eliminado exitosamente" })
							.then(() => {
								this.broadcast.reloadDataTable();
								this.reelTimeline = [];
								this.reelTimelineBase = [];

								this.selectedReel = null;
								this.selectedReelId = null;
								this.selectedReelName = null;

								this.totalDurationSelected = "00:00";
								this.totalDurationSelectedBase = "00:00";
							});
					} else {
						this.swal.error(
							"Ocurrio un error al intentar borrar el Reel",
						);
					}
				});
			}
		});
	}

	async onCampaniaChange(groupId: number | null): Promise<void> {
		if (groupId === null) {
			return;
		}

		this.Group_id = Number(groupId);
		this.currentGroup_id = this.Group_id;

		await this.router.navigate([
			"/client/config/design-reels",
			this.Group_id,
		]);
	}

	async obtenerReel(): Promise<void> {
		try {
			const reels = this.Group_id
				? await this.reelsService.ShowByGroup(this.Group_id)
				: await this.reelsService.showAll();

			this.ReelsByUser = await Promise.all(
				reels.map(async (reel: any) => {
					const response = await this.reelsService.show(reel.id);

					const medias: MediaItem[] = (
						response?.response?.medias || []
					).map((media: any) => this.normalizeTimelineMedia(media));

					const totalSeconds = medias.reduce(
						(total: number, media: MediaItem) =>
							total + (Number(media.duration_seconds) || 0),
						0,
					);

					return {
						...reel,
						medias,
						totalDuration: this.formatDuration(totalSeconds),
					};
				}),
			);
		} catch (error) {
			console.error("Error al obtener los reels:", error);
		}
	}

	async getMedias() {
		if (this.medias === this.repertorioBase) {
			this.isLoading = true;
			const result = await this.mediasService.getMediasByType("VIDEO");
			this.repertorio = result;
			this.repertorioBase = result;
			this.medias = result;
			this.isLoading = false;
		} else {
			this.mediasService.getMediasByType("VIDEO").then((data) => {
				this.medias = data;
			});
		}

		if (this.photos === this.repertorioBase) {
			this.isLoading = true;
			const result = await this.mediasService.getMediasByType("IMAGE");

			this.repertorio = result;
			this.repertorioBase = result;
			this.photos = result;
			this.isLoading = false;
		} else {
			this.mediasService.getMediasByType("IMAGE").then((data) => {
				this.photos = data;
			});
		}
	}

	removeFromTimeline(index: number, clip: any) {
		if (index > -1 && index < this.reelTimeline.length) {
			this.reelTimeline.splice(index, 1);
			this.removeDuration(clip.duration_seconds);
		}
	}

	formatDuration(seconds: number | null | undefined): string {
		if (!seconds || seconds < 0) return "00:00";

		const mins = Math.floor(seconds / 60);
		const secs = Math.floor(seconds % 60);

		const pad = (n: number) => n.toString().padStart(2, "0");
		return `${pad(mins)}:${pad(secs)}`;
	}

	filterRepertorio(): void {
		const term = this.searchTerm.trim().toLowerCase() || "";

		this.repertorio = this.repertorioBase.filter((media) => {
			const coincideTexto =
				!term || media.name.toLowerCase().includes(term);

			/* Filtro por vigencia */
			const coincideVigencia =
				!this.soloVigentes || this.puedeArrastrarMedia(media);

			return coincideTexto && coincideVigencia;
		});
	}

	onDropTimeline(event: CdkDragDrop<MediaItem[]>) {
		const fromList = event.previousContainer.data;
		const toList = event.container.data;

		const isSameList = event.previousContainer === event.container;

		if (isSameList) {
			// reorder interno en timeline
			moveItemInArray(toList, event.previousIndex, event.currentIndex);
			return;
		}

		// viene desde repertorio -> timeline
		const draggedItem = fromList[event.previousIndex];
		this.addDuration(draggedItem.duration_seconds);

		const cloned: MediaItem = {
			...draggedItem,
			id: draggedItem.id,
			assigned_time: "",
		};

		toList.splice(event.currentIndex, 0, cloned);
	}

	addDuration(draggedSeconds: number): void {
		const currentSeconds = this.timeToSeconds(this.totalDurationSelected);
		const newTotal = currentSeconds + draggedSeconds;

		this.totalDurationSelected = this.formatDuration(newTotal);
	}

	removeDuration(secondsToRemove: number): void {
		const currentSeconds = this.timeToSeconds(this.totalDurationSelected);
		let newTotal = currentSeconds - secondsToRemove;

		if (newTotal < 0) {
			newTotal = 0;
		}

		this.totalDurationSelected = this.formatDuration(newTotal);
	}

	private timeToSeconds(time: string): number {
		if (!time) return 0;
		const [mm, ss] = time.split(":").map(Number);
		return mm * 60 + ss;
	}

	onDropRepertorio(event: CdkDragDrop<MediaItem[]>) {
		// catálogo fijo, no hacemos nada
		return;
	}

	saveTimeline(): void {
		if (!this.selectedReelId) {
			return;
		}

		this.message = "Guardando Reel...";
		this.isLoading = true;

		const selectedValues = this.reelTimeline.map(
			(element: MediaItem, index: number) => ({
				media_id: element.id,

				/*
				 * Enviar null cuando corresponde
				 * a todo horario.
				 */
				assigned_time: element.assigned_time || null,

				/*
				 * Opcional, si el backend guarda
				 * explícitamente la posición.
				 */
				order: index + 1,
			}),
		);

		const payload = {
			medias: selectedValues,
		};

		this.reelsService
			.saveMedias(payload, this.selectedReelId)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe({
				next: async () => {
					this.isLoading = false;

					await this.refreshSelectedReelAfterSave();

					this.swal.success();
				},
				error: (error) => {
					this.isLoading = false;

					console.error("Error al guardar el reel:", error);

					this.swal.error(
						"No fue posible guardar la línea de tiempo",
					);
				},
			});
	}

	cancelTimeline(): void {
		this.reelTimeline = this.reelTimelineBase.map((media: MediaItem) => ({
			...media,
		}));

		this.totalDurationSelected = this.totalDurationSelectedBase;
	}

	edit_reel(): void {
		this.broadcast.fire({
			name: "reels.edit",
			type: EventType.MODAL,
			data: {},
		});
	}

	duplicate_reel(): void {
		console.log("probando metodo");
		this.broadcast.fire({
			name: "reels.duplicate",
			type: EventType.MODAL,
			data: {},
		});
	}

	puedeArrastrarMedia(media: any): boolean {
		if (!media?.vigencia) {
			return false;
		}

		const fechaVigencia = new Date(media.vigencia);

		/*
		 * Ajusta al final del día local.
		 */
		fechaVigencia.setHours(23, 59, 59, 999);

		const ahora = new Date();

		return ahora <= fechaVigencia;
	}

	isDisabled(reel: any): boolean {
		/* Arrastrable solo si aún no vence */
		return reel.active != 0;
	}

	/*
	 * Sincroniza ReelsByUser utilizando la información
	 * que actualmente está visible en el editor.
	 */
	private updateSelectedReelLocally(): void {
		if (!this.selectedReelId) {
			return;
		}

		const timelineCopy = this.reelTimeline.map((media: MediaItem) => ({
			...media,
		}));

		const totalSeconds = timelineCopy.reduce(
			(total: number, media: MediaItem) =>
				total + (Number(media.duration_seconds) || 0),
			0,
		);

		const totalDuration = this.formatDuration(totalSeconds);

		this.ReelsByUser = this.ReelsByUser.map((reel: any) => {
			if (Number(reel.id) !== Number(this.selectedReelId)) {
				return reel;
			}

			return {
				...reel,
				medias: timelineCopy,
				totalDuration,
			};
		});

		const updatedSelectedReel = this.ReelsByUser.find(
			(reel: any) => Number(reel.id) === Number(this.selectedReelId),
		);

		if (updatedSelectedReel) {
			this.selectedReel = updatedSelectedReel;
		}

		this.reelTimelineBase = timelineCopy.map((media: MediaItem) => ({
			...media,
		}));

		this.totalDurationSelected = totalDuration;

		this.totalDurationSelectedBase = totalDuration;
	}

	async selectReel(r: any): Promise<void> {
		this.isLoadingRepertorio = true;

		this.reelTimeline = (r.medias || []).map((media: any) =>
			this.normalizeTimelineMedia(media),
		);

		this.reelTimelineBase = this.reelTimeline.map((media: MediaItem) => ({
			...media,
		}));

		this.selectedReelId = r.id;
		this.selectedReelName = r.name;
		this.selectedReel = r;
		this.totalDurationSelected = r.totalDuration;
		this.totalDurationSelectedBase = r.totalDuration;

		if (r.type !== this.CurrentType) {
			this.CurrentType = r.type;

			if (r.type === "VIDEO") {
				if (this.medias.length > 0) {
					this.repertorio = [...this.medias];
					this.repertorioBase = [...this.medias];
				} else {
					const result = await this.mediasService.getMediasByType(
						r.type,
					);

					this.repertorio = result;
					this.repertorioBase = result;
					this.medias = result;
				}
			} else {
				if (this.photos.length > 0) {
					this.repertorio = [...this.photos];
					this.repertorioBase = [...this.photos];
				} else {
					const result = await this.mediasService.getMediasByType(
						r.type,
					);

					this.repertorio = result;
					this.repertorioBase = result;
					this.photos = result;
				}
			}
		}

		this.filterRepertorio();
		this.isLoadingRepertorio = false;
	}

	createNewReel(): void {
		this.broadcast.fire({
			name: "reels.add",
			type: EventType.MODAL,
			data: {},
		});
	}

	createNewMedia(): void {
		this.broadcast.fire({
			name: "medias.add",
			type: EventType.MODAL,
			data: {},
		});
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.next();
		this.atComponentDestroy.complete();
	}

	hasExpiredItems(): boolean {
		return (
			this.reelTimeline?.some(
				(clip: any) => !this.puedeArrastrarMedia(clip),
			) ?? false
		);
	}

	/* Elimina vencidos y recalcula la duración total */
	removeExpiredFromTimeline(): void {
		if (!this.reelTimeline?.length) {
			this.totalDurationSelected = this.formatDuration(0);
			return;
		}

		this.reelTimeline = this.reelTimeline.filter((clip: any) =>
			this.puedeArrastrarMedia(clip),
		);

		const totalSeconds = this.reelTimeline.reduce(
			(total: number, clip: any) =>
				total + (Number(clip.duration_seconds) || 0),
			0,
		);

		this.totalDurationSelected = this.formatDuration(totalSeconds);
	}

	removeAllFromTimeline(): void {
		if (!this.reelTimeline || this.reelTimeline.length === 0) {
			return;
		}

		this.totalDurationSelected = this.formatDuration(0);

		this.reelTimeline = [];
	}

	/*
	 * Acciones secundarias de la campaña seleccionada.
	 */
	get campaignActions(): MenuItem[] {
		return [
			{
				label: "Editar campaña",
				icon: "pi pi-pencil",
				command: () => {
					this.edit_reel();
				},
			},
			{
				label: "Duplicar campaña",
				icon: "pi pi-copy",
				command: () => {
					this.duplicate_reel();
				},
			},
			{
				separator: true,
			},
			{
				label: "Eliminar campaña",
				icon: "pi pi-trash",
				styleClass: "campaign-menu-danger",
				command: () => {
					this.delete_reel();
				},
			},
		];
	}

	private normalizeTimelineMedia(media: any): MediaItem {
		const assignedTime =
			media?.assigned_time ?? media?.pivot?.assigned_time ?? "";

		return {
			...media,
			assigned_time:
				assignedTime === "mat" || assignedTime === "ves"
					? assignedTime
					: "",
		};
	}
}
